export enum MobilePaymentStatus {
  SUCCESSFUL = 'SUCCESSFUL',
  PENDING = 'PENDING',
  FAILED = 'FAILED',
  DISABLED = 'DISABLED',
  INSUFFICIENT_FUNDS = 'INSUFFICIENT_FUNDS',
}
